import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import * as t from 'io-ts';
import GENDER, { GenderEnumType } from '../enums/gender';

export const UserProfilePersonalityType = t.interface({
    lastName: t.union([t.string, t.null, t.undefined]),
    birthday: t.union([t.string, t.null, t.undefined]),
    firstName: t.union([t.string, t.null, t.undefined]),
    middleName: t.union([t.string, t.null, t.undefined]),
    gender: t.union([GenderEnumType, t.null, t.undefined]),
});

export interface UserProfilePersonalityDto extends t.TypeOf<typeof UserProfilePersonalityType> {
}

class UserProfilePersonality {
    lastName: string | null;
    birthday: string | null;
    firstName: string | null;
    middleName: string | null;
    gender: SimpleObjectInterface | null;

    constructor(params: UserProfilePersonalityDto) {
        this.birthday = params.birthday ?? null;
        this.lastName = params.lastName ?? null;
        this.firstName = params.firstName ?? null;
        this.middleName = params.middleName ?? null;
        this.gender = params.gender
            ? GENDER[params.gender]
            : null;
    }
}

export default UserProfilePersonality;
